import { Card, CardContent } from '@billda/design-system';
import { ExitToAppIcon } from '@billda/design-system';
import { UserOffboardingInfoDto } from '../../../api/userManagementApi';

interface UserOffboardingCardProps {
  offboardingInfo: UserOffboardingInfoDto;
  formatDateTime: (dateString: string) => string;
}

function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between">
      <span className="type-body-md text-content-secondary">{label}</span>
      <span className="type-body-md font-medium">{value}</span>
    </div>
  );
}

export function UserOffboardingCard({
  offboardingInfo,
  formatDateTime,
}: UserOffboardingCardProps) {
  return (
    <Card data-testid="user-offboarding-card">
      <CardContent className="pt-4">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <ExitToAppIcon
              aria-hidden="true"
              className="size-4 text-content-secondary"
            />
            <h3 className="type-h6">Offboarding</h3>
          </div>

          <div className="flex flex-col gap-2">
            <DetailRow label="Started By" value={offboardingInfo.startedBy} />

            <DetailRow
              label="Started At"
              value={formatDateTime(offboardingInfo.startedAt)}
            />

            {offboardingInfo.completedBy && (
              <DetailRow
                label="Completed By"
                value={offboardingInfo.completedBy}
              />
            )}

            {offboardingInfo.completedAt && (
              <DetailRow
                label="Completed At"
                value={formatDateTime(offboardingInfo.completedAt)}
              />
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
